<template>
  <div>
    <Drawer
    :visible.sync="elDrawer"
    direction="rtl"
    size="500px"
    :modal="true"
    :withHeader="false"
    :append-to-body="true"
    class="default-drawer">
    <Link :underline="false" class="nav-close" @click="closeEditSlider">
        <svgicon name="cancelwhite" width="12" height="12" :original="true" />
    </Link>
    <div class="drawer-body">
      <div class="drawer-header px-15">
        {{$t('INDENT_REJECTIONS')}}
      </div>
      <div class="drawer-body p-0 list-group" style="overflow:auto;">
      <div style="left: 56px; position: relative;" class="list-group-item" :key="'rejection-' + index" v-for="(rejections,index) in  currentInvalidRejections">
            <Link
                v-if="!!rejections.count"
                @click="downloadFile(rejections.s3Path)"
                :underline="false"
                class="text-link text-sm text-bold text-blue-dark3"
              >
                <span :key="index"> {{$t('MDM_REJECTION')}} {{index+1}}</span>
              </Link>
      </div>
      </div>
    </div>
    </Drawer>
    <Drawer
    :visible.sync="elDrawerStatus"
    direction="rtl"
    size="500px"
    :modal="true"
    :withHeader="false"
    :append-to-body="true"
    class="default-drawer">
    <Link :underline="false" class="nav-close" @click="closeStatusSlider">
        <svgicon name="cancelwhite" width="12" height="12" :original="true" />
    </Link>
    <div class="drawer-body">
      <div class="drawer-header px-15">
          {{$t('MDM_STATUS')}}
      </div>
      <div class="list-group" style="overflow:auto;">
        <div class="d-flex mb-10">
          <Button type="secondary" size="mini" plain class="ml-auto" @click="refreshStatusScreen">
            <span>{{$t('MDM_REFRESH')}}</span>
        </Button>
        </div>
      <Table
      :data="currentBatches"
      :stripe="true"
      :max-height="windowHeight"
      class="table-striped bordered no-highlight my-30">
      <TableColumn prop="option" valign="center" :label="$t('MDM_BATCH')" colspan="3">
        <template slot-scope="scope">
          {{scope.$index * 1000 + 1}} - {{scope.$index * 1000 + scope.row.count}}
        </template>
        </TableColumn>
        <TableColumn prop="option" valign="center" :label="$t('MDM_COUNT')" colspan="2">
        <template slot-scope="scope">
          {{scope.row.count}}
        </template>
        </TableColumn>
        <TableColumn prop="option" valign="center" :label="$t('MDM_STATUS')" colspan="3">
        <template slot-scope="scope">
          {{ $t(frontEndStatusMapper[scope.row.status]) || scope.row.status }}
        </template>
        </TableColumn>
      </Table>
      </div>


    </div>
    </Drawer>
    <Drawer class="default-drawer"
      direction="rtl"
      size="500px"
      :modal="true"
      :withHeader="false"
      :append-to-body="true"
      :visible.sync="elDrawerApprovals">
      <Link :underline="false" class="nav-close" @click="closeApprovalSlider">
          <svgicon name="cancelwhite" width="12" height="12" :original="true" />
      </Link>
      <div class="drawer-body">
        <div class="drawer-header px-15"> {{$t('MDM_APPROVAL_STATUS')}} </div>
        <div class="list-group" style="overflow:auto;">
          <Table class="table-striped bordered no-highlight my-30"
            :data="currentApprovals"
            :stripe="true"
            :max-height="windowHeight" 
            aria-describedby="approvals"
            >
            <TableColumn prop="option" valign="center" :label="$t('MDM_LEVEL')" colspan="3">
              <template slot-scope="scope"> Level {{scope.$index + 1}} </template>
            </TableColumn>
            <TableColumn prop="option" valign="center" :label="$t('MDM_ROLE')" colspan="3">
              <template slot-scope="scope"> {{ scope.row.roleName }} </template>
            </TableColumn>
            <TableColumn prop="option" valign="center" :label="$t('MDM_STATUS')" colspan="3">
              <template slot-scope="scope">
                {{ $t(frontEndApprovalStatusMapper[scope.row.status]) || scope.row.status }}
              </template>
            </TableColumn>
          </Table>
        </div>
      </div>
    </Drawer>
    <portal target-el="#filter">
      <div class="sub-header">
        <div class="header-item">
          <Breadcrumb type="flex" separator-class="el-icon-arrow-right">
            <breadcrumb-item :to="routeToMdmPath">
              {{$t('MDM_ALL_MASTERS')}}
            </breadcrumb-item>
            <breadcrumb-item> {{$t('MDM_UPLOAD')}} </breadcrumb-item>
          </Breadcrumb>
        </div>
      </div>
    </portal>
    <div class="card-boxed bg-white">
      <div class="d-flex mb-10">
          <Button type="secondary" size="mini"  plain class="ml-auto" @click="fetchTableData">
              <span>{{$t('MDM_REFRESH')}}</span>
          </Button>
        </div>
      <div class="table-with-add text-multiline mt-10">
        <div class="add-block" @click="uploadNewMaster()">
          <span>{{$t('MDM_NEW_MASTER_UPLOAD')}}</span>
          <small>{{$t('MDM_ADD_NEW_MASTERS')}}</small>
        </div>
        <Table
          :data="tableData"
          :max-height="windowHeight"
          class="table-striped bordered no-highlight my-30"
          aria-describedby="mdmUploadData"
          >
          <TableColumn prop="option" valign="center" :label="$t('MDM_MASTER')">
            <template slot-scope="scope">
              <Select
                :disabled="!isPending(scope.row)"
                v-model="scope.row.masterSelectvalue"
                size="mini"
                placeholder="Select Master"
                class="select-default no-bg ml-m10"
                @change="onChangeMasterSelectValue(scope.row.masterSelectvalue, scope.$index)"
              >
                <Option
                  v-for="item in scope.row.menuOptionData"
                  :key="item.id"
                  :label="item.name"
                  :value="item.name"
                >
                </Option>
              </Select>
            </template>
          </TableColumn>
          <TableColumn :label="$t('MDM_OPTION')">
            <template slot-scope="scope">
              <Select
                v-model="scope.row.subUploadValue"
                size="mini"
                placeholder="Select Upload type"
                class="select-default no-bg ml-m10"
                :disabled="!isPending(scope.row)"
                @change="onChangeSubUploadValue(scope.row.subUploadValue, scope.$index)"
              >
                <Option
                  v-for="item in scope.row.options"
                  :key="item.id"
                  :label="item.name"
                  :value="item.name"
                >
                </Option>
              </Select>
            </template>
          </TableColumn>
          <TableColumn :label="$t('MDM_FILE')">
            <template slot-scope="scope">
              <span>
                <span v-if="!isPending(scope.row)">
                  <Link
                    @click="downloadFile(scope.row.fileName ,scope.row.masterSelectvalue)"
                    :underline="false"
                    class="text-link text-sm text-bold text-blue-dark3"
                  >
                    <span>{{ getFileName(scope.row.fileName) }}</span>
                  </Link>
                </span>
                <span v-else>
                      <span v-if="!!scope.row.fileName">
                            <Link
                              download
                              :href="`${$asset_path}static/sample/${scope.row.fileName}`"
                              :underline="false"
                              class="text-link text-sm text-bold text-blue-dark3"
                            >
                              <span>{{$t('MDM_DOWNLOAD_SAMPLE_FILE')}}</span>
                            </Link>
                      </span>
                      <span v-else>
                          <Link
                          :disabled="checkSubValueSelected(scope.row.fileName, scope.row.subUploadValue)"
                            @click="getExcelFile(getIdBySectionName.get(scope.row.masterSelectvalue), scope.row.subUploadValue)"
                            :underline="false"
                            :class="`${checkSubValueSelected(scope.row.fileName, scope.row.subUploadValue) ? 'text-link text-sm text-bold text-gray-dark3' : 'text-link text-sm text-bold text-blue-dark3'}`"
                          >
                            <span>{{$t('MDM_DOWNLOAD_SAMPLE_FILE')}}</span>
                          </Link>
                      </span>
                </span>
              </span>
            </template>
          </TableColumn>
          <TableColumn :label="$t('MDM_STATUS')" width="200">
            <template slot="header" slot-scope="scope">
              <a href="#" @click.prevent="toggleDropdown"
                class="dropdown dropdown-toggle dark"
                :class="{'show': isOpenFilterToggle}" ref="btnToggle">
                  <span v-if="!isOpenFilterToggle">{{$t('MDM_STATUS')}}</span>
                  <span v-else>{{$t('MDM_FILTER_BY')}}</span>
                <svgicon name="icon-down-arrow" width="10" height="10" class="mt-m5" :original="true"/>
              </a>
              <div class="dropdown-menu" v-show="isOpenFilterToggle" v-click-outside="closeFilterToggle"
              :class="{'show': isOpenFilterToggle}" >
                <ul class="list-unstyled dark">
                  <div v-for="(option, idx) in filterOptions" :key="idx"
                    @click="updateFilterOption(idx)">
                    <li class="list-with-icon" :class="{ 'active active-text':
                      '', 'pointer': !option.selected }">
                    <svgicon v-if="option.selected"
                      name="icon-tick-sm" width="8" height="8" :original="true"/>
                      {{$t(option.tlabel)}}
                    <span v-if="option.selected" class="f-right sm-text pointer" @click="clearFilterSelection(idx)">Clear</span>
                    </li>
                  </div>
                </ul>
              </div>
            </template>
            <template slot-scope="scope">
              <span
                v-if="
                  scope.row.status === mdmUploadStatus.UPLOAD_STARTED
                "
              >
                <span class="status status-purple">
                  {{ $t(frontEndStatusMapper[scope.row.status]) || scope.row.status }}
                </span>
                <span class="loading-spinner" v-if="loadingItem.includes(scope.row.id)">
                </span>
              </span>
              <span
                class="status status-green"
                v-else-if="
                  [
                    mdmUploadStatus.APPROVED,
                    mdmUploadStatus.UPLOAD_IN_PROGRESS,
                    mdmUploadStatus.VALIDATION_COMPLETED,
                  ].includes(scope.row.status)
                "
              >
                {{ $t(frontEndStatusMapper[scope.row.status]) || scope.row.status }}
              </span>
              <span
                class="status status-yellow"
                v-else-if="
                  [
                    mdmUploadStatus.APPROVAL_PENDING,
                  ].includes(scope.row.status)
                "
              >
                {{ $t(frontEndStatusMapper[scope.row.status]) || scope.row.status }}
              </span>
              <span
                class="status status-red"
                v-else-if="
                  [
                    mdmUploadStatus.UPLOAD_DISCARDED,
                    mdmUploadStatus.UPLOAD_PARTIAL_FAILED,
                    mdmUploadStatus.UPLOAD_FAILED,
                  ].includes(scope.row.status)
                "
              >
                {{ $t(frontEndStatusMapper[scope.row.status]) || scope.row.status }}
              </span>
              <span
                class="status status-pink"
                v-else-if="
                  [
                    mdmUploadStatus.APPROVAL_REJECTED,
                  ].includes(scope.row.status)
                "
              >
                {{ $t(frontEndStatusMapper[scope.row.status]) || scope.row.status }}
              </span>
              <span
                class="status status-green"
                v-else-if="
                  [mdmUploadStatus.UPLOAD_COMPLETED].includes(
                    scope.row.status
                  )
                "
              >
                {{ $t(frontEndStatusMapper[scope.row.status]) || scope.row.status }}
              </span>
              <span v-if="loading && !scope.row.status">
                <span class="status status-blue">
                  {{$t('MDM_UPLOADING')}}
                </span>
                <span class="loading-spinner"></span>
              </span>
            </template>
          </TableColumn>
          <TableColumn :label="$t('MDM_UPLOADED_BY')">
            <template slot-scope="scope">
              <small class="d-block">{{ scope.row.uploadedBy }}</small>
            </template>
          </TableColumn>
          <TableColumn :label="$t('MDM_VALID_ENTRIES')">
            <template slot-scope="scope">
              <span class="text-green-dark" v-if="totalValidRecordsCount(scope.row.valid)">{{ totalValidRecordsCount(scope.row.valid) }}</span>
              <div v-else> __ </div>
            </template>
          </TableColumn>
          <TableColumn valign="center" :label="$t('MDM_INVALID_ENTRIES')">
            <template slot-scope="scope" v-if= "![mdmUploadStatus.UPLOAD_DISCARDED, mdmUploadStatus.APPROVAL_REJECTED].includes(
                    scope.row.status)">
                <div v-if="totalInvalidRecordsCount(scope.row.invalid)" class="text-red"> {{ totalInvalidRecordsCount(scope.row.invalid) }}</div>
                <div v-else> __ </div>
                <Link
                 v-if="!isPending(scope.row) && isInvalidPresent(scope.row.invalid)"
                  @click="openDrawer(scope.row.invalid, scope.row.masterSelectvalue)"
                  :underline="false"
                  class="text-link text-sm text-bold text-blue-dark3"
                >
                  <span> {{$t('MDM_REJECTED_LIST')}} </span>
                </Link>
            </template>
          </TableColumn>
          <TableColumn valign="center" :label="$t('MDM_STATUS_CHECK')">
            <template slot-scope="scope">
                <Link
                 v-if="!isPending(scope.row)"
                  @click="openStatusDrawer(scope.row.id, scope.row.splitObject)"
                  :underline="false"
                  class="text-link text-sm text-bold text-blue-dark3"
                >
                  <span>{{$t('MDM_CHECK_STATUS')}}</span>
                </Link>
                <br />
                <Link class="text-link text-sm text-bold text-blue-dark3"
                  v-if="!isPending(scope.row) && scope.row.event_approvals &&
                   scope.row.event_approvals.approval_levels &&
                   [mdmUploadStatus.APPROVAL_REJECTED, mdmUploadStatus.APPROVAL_PENDING]
                     .includes(scope.row.status)"
                    @click="openApprovalDrawer(scope.row.id,
                      scope.row.event_approvals.approval_levels)"
                    :underline="false">
                  <span>{{$t('MDM_CHECK_APPROVAL_STATUS')}} </span>
                </Link>
            </template>
          </TableColumn>

         <TableColumn valign="center" width="230">
            <template slot-scope="scope">
              <div class="d-flex action-row mt-m15 no-bg">
                <Button
                  @click="upload(scope.row)"
                  v-if="isPending(scope.row)"
                  type="primary" size="small">{{$t('MDM_UPLOAD')}}
                </Button>
                <span  class="d-flex action-row mt-m10 no-bg" v-if="
                  ((clientConfigApproval && scope.row.subUploadValue === 'Rate Matrix Bulk Upload') ||
                  scope.row.canApprove)&&
                  [mdmUploadStatus.APPROVAL_PENDING].includes(scope.row.status) &&
                  scope.row.isUploaded &&
                  !scope.row.isApproved &&
                  !scope.row.isRejected">
                  <div v-if="!scope.row.hide">
                  <Popover
                    placement="bottom"
                    popper-class="overlay-popup"
                    width="400">
                    <div class="popover-body bg-white p-15" >
                      <div class="popover-header mb-10">{{$t('MDM_REJECT_MASTER_UPLOAD')}}</div>
                      <p>
                      Are you sure you want to Reject the upload of
                      {{ scope.row.masterSelectvalue }}?
                      </p>
                      <span>
                        <Input
                        v-model="scope.row.rejectionMessage"
                        :placeholder="$t('MDM_REJECTION_MESSAGE_REQUEST')"
                        />
                      </span>
                      <div @click="isRejectSelected = false" class="popover-footer text-right mt-10">
                        <Button type="secondary" @click="cancel()" size="mini"> {{$t('MDM_CANCEL')}} </Button>
                        <Button
                          @click="confirmReject(scope.row, scope.$index)"
                          type="danger"
                          size="mini"
                          >
                        {{$t('MDM_REJECT')}}
                        </Button>
                      </div>
                    </div>
                    <Button
                      @click="reject(scope.row.id)"
                      slot="reference"
                      size="small"
                      type="secondary">{{$t('MDM_REJECT')}}
                    </Button>
                  </Popover>
                  </div>
                  <span ref='ref-popup-close' id="ref-popup-close"></span>
                  <div v-if="!scope.row.hide" class="ml-20">
                      <Button
                        @click="approve(scope.row, scope.$index)"
                        size="small"
                        type="primary">{{$t('MDM_APPROVE')}}
                      </Button>
                  </div>
                </span>
                <span class="d-flex action-row mt-m10 no-bg" v-else-if="
                    clientConfigApproval &&
                    [mdmUploadStatus.VALIDATION_COMPLETED].includes(
                      scope.row.status
                    ) &&
                    scope.row.isUploaded ">
                  <Button
                    @click="deleteItem(scope.row.id)"
                    size="small"
                    type="secondary">{{$t('MDM_DISCARD')}}
                  </Button>
                  <div
                    v-if="!isConfirmButtondisabled(scope.row)"
                  >
                    <Button
                      @click="confirm(scope.row.id, scope.row.subUploadValue)"
                      size="small"
                      class="ml-20"
                      type="primary">{{$t('MDM_CONFIRM')}}
                    </Button>
                  </div>
                  <Tooltip class="item" effect="dark" placement="bottom" v-else>
                    <div slot="content" class="tooltipcontent"> {{ $t('MDM_CONFIRM_DISABLED_MESSAGE') }} </div>
                    <span class="pointer">
                    <Button
                      class="ml-5"
                      :disabled="isConfirmButtondisabled(scope.row)"
                      size="small"
                      type="primary">{{$t('MDM_CONFIRM')}}</Button>
                    </span>
                 </Tooltip>
                </span>
                <span class="d-flex action-row mt-m10 no-bg" v-else-if="
                    !clientConfigApproval &&
                    [mdmUploadStatus.VALIDATION_COMPLETED].includes(
                      scope.row.status
                    ) &&
                    scope.row.isUploaded ">
                  <Button
                    @click="deleteItem(scope.row.id)"
                    size="small"
                    type="secondary">{{$t('MDM_DISCARD')}}
                  </Button>
                  <div
                    v-if="!isConfirmButtondisabled(scope.row)"
                  >
                    <Button
                      @click="confirm(scope.row.id, scope.row.subUploadValue)"
                      size="small"
                      class="ml-20"
                      type="primary">{{$t('MDM_CONFIRM')}}
                    </Button>
                  </div>
                  <Tooltip class="item" effect="dark" placement="bottom" v-else>
                    <div slot="content" class="tooltipcontent"> {{ $t('MDM_CONFIRM_DISABLED_MESSAGE') }} </div>
                    <span class="pointer">
                    <Button
                      class="ml-5"
                      :disabled="isConfirmButtondisabled(scope.row)"
                      size="small"
                      type="primary"> {{$t('MDM_CONFIRM')}} </Button>
                    </span>
                 </Tooltip>
                </span>
              </div>
              <span class="f-right"
                  v-if="
                    [
                    mdmUploadStatus.UPLOAD_STARTED,
                    mdmUploadStatus.UPLOAD_IN_PROGRESS].includes(
                      scope.row.status
                    )
                  "
                >
                <Tooltip :open-delay="100" effect="dark" placement="bottom">
                  <div slot="content">{{ $t('MDM_FORCE_DISCARD_BUTTON_CONFIRMATION') }}</div>
                  <i @click="deleteItem(scope.row.id)">
                  <svgicon name="icon-delete-md" width="14" height="14"/>
                  </i>
                </Tooltip>
              </span>
            </template>
          </TableColumn>
          <infinite-loading
            v-if="!isEmptyData"
            slot="append"
            @infinite="loadData"
            force-use-infinite-wrapper=".el-table__body-wrapper"
                  >
                    <div slot="no-more"></div>
                    <div slot="no-results"></div>
          </infinite-loading>
        </Table>
        <label>
          <input
            class="upload-material"
            type="file"
            id="additional-upload"
            :ref="'additionalUpload'"
            :accept="AttachmentConstants.excelMimes"
            @change="handleFileUpload"
          />
        </label>
      </div>
    </div>
  </div>
</template>

<script>
import { cloneDeep, groupBy } from 'lodash';
import { mapGetters } from 'vuex';
import PrimaryFilter from '@/components/common/PrimaryFilter';
import SharedMdm from '@/components/mixins/SharedMdmV2';
import {
  mdmUploadPageConstants,
  sampleFileNameMaster,
  additionalUploads,
  AttachmentConstants,
  menuOptionData,
  frontEndStatusMapper,
  filterOptions,
  filterOptionsForApprover,
  frontEndApprovalStatusMapper,
} from '@/constants/mdm-v2/uploadConstants';
import { bfrMapper } from '../../../constants/mdm-v2/pageConstants';

// eslint-disable-next-line import/no-extraneous-dependencies
const { mdmUploadStatus } = require('pando-constants');

export default {
  data() {
    return {
      loading: false,
      sel: {},
      isEmptyData: false,
      menuOptionData,
      tableData: [],
      isRejectSelected: false,
      clientConfigApproval: false,
      sampleFileNameMaster,
      getSectionNameById: {},
      getIdBySectionName: {},
      additionalUploads,
      currentRowData: {},
      mdmUploadPageConstants,
      mdmUploadStatus,
      rejectSelectedId: null,
      file: new File([], 'sample'),
      loadingItem: [],
      maxTries: 30,
      counter: 0,
      intervalId: null,
      currentPage: 1,
      params: {},
      elDrawer: false,
      elDrawerStatus: false,
      elDrawerApprovals: false,
      currentInvalidRejections: [],
      currentBatches: [],
      currentApprovals: [],
      currentSelectedBulkUploadId: null,
      AttachmentConstants,
      frontEndStatusMapper,
      frontEndApprovalStatusMapper,
      selectedRejectionMaster: null,
      isOpenFilterToggle: false,
      filterClicked: false,
      filterOptions,
      filterOptionsForApprover,
      statuses: [],
    };
  },
  components: {
    PrimaryFilter,
  },
  mixins: [SharedMdm],
  props: {
    previousRoute: {
      type: String,
      default: null,
    },
    type: {
      type: String,
      default: 'user',
    },
  },
  computed: {
    ...mapGetters({
      bootstrapData: 'app/bootstrapData',
      roles: 'role/all',
    }),
    routeToMdmPath() {
      return { name: 'MDM' };
    },
    windowHeight() {
      return `${window.innerHeight - 200}px`;
    },
    totalInvalidRecordsCount() {
      return (invalid) => {
        const invalidCount = invalid ? invalid.reduce((total, invalidElement) => {
          total += invalidElement.count;
          return total;
        }, 0) : 0;
        return invalidCount;
      };
    },
    totalValidRecordsCount() {
      return (valid) => {
        const validCount = valid ? valid.reduce((total, validElement) => {
          total += validElement.count;
          return total;
        }, 0) : 0;
        return validCount;
      };
    },
  },
  methods: {
    closeFilterToggle() {
      if (!this.filterClicked) {
        this.isOpenFilterToggle = false;
      }
      this.filterClicked = false;
    },
    clearFilterSelection(index) {
      this.filterOptions[index].selected = false;
      this.filterOptions[index].cleared = true;
    },
    async updateFilterOption(index) {
      if (!this.filterOptions[index].cleared) {
        this.filterOptions[index].selected = true;
      }
      if (this.filterOptions[index].cleared) {
        this.filterOptions[index].cleared = false;
      }
      this.toggleDropdown();
      this.statuses = this.filterOptions.filter(statusObject => statusObject.selected === true)
        .map(statusObject => statusObject.query);
      await this.fetchTableData();
    },
    toggleDropdown() {
      // eslint-disable-next-line no-sequences
      this.isOpenFilterToggle = !this.isOpenFilterToggle;
      this.filterClicked = true;
    },
    checkSubValueSelected(item, subType) {
      return subType ? !subType : !item;
    },
    checkPermission() {
      return Object.keys(this.additionalUploads).filter((subUpload) => {
        const subUploadCheck = this.additionalUploads[subUpload].filter(subType => (!subType.permission || this.$hasPermission(subType.permission)) && (!subType.feature || this.$hasFeature(subType.feature)));
        return subUploadCheck && subUploadCheck.length;
      });
    },
    openDrawer(currentInvalidRejections, selectedMaster) {
      this.elDrawer = true;
      const invalidRejections = currentInvalidRejections.filter(invalid => invalid && invalid.count > 0);
      this.currentInvalidRejections = invalidRejections;
      this.selectedRejectionMaster = selectedMaster;
    },
    isInvalidPresent(rejections) {
      let shouldShowRejectionsLink = false;
      rejections.forEach((rejection) => {
        if (rejection && rejection.count !== 0) {
          shouldShowRejectionsLink = true;
        }
      });
      return shouldShowRejectionsLink;
    },
    isConfirmButtondisabled({ subUploadValue, splitObject: splits, invalid: rejections }) {
      let shouldDisableConfirmButton = false;
      // For now the type is hardcoded to rate-matrix. Need to handle it later to support more types client specific
      if (subUploadValue === 'Rate matrix Bulk Upload' && this.$hasFeature('bulk_upload_approval_flow')) {
        shouldDisableConfirmButton = true;
        if (splits && splits.length) {
          splits.forEach((split) => {
            const rejectionForThisSplit = rejections.find(rejection => rejection.splitNo === split.splitNo);
            if (rejectionForThisSplit.count < split.count) {
              shouldDisableConfirmButton = false;
            }
          });
        }
      }
      return shouldDisableConfirmButton;
    },

    openStatusDrawer(id, splits) {
      this.elDrawerStatus = true;
      this.currentSelectedBulkUploadId = id;
      this.currentBatches = splits;
    },
    openApprovalDrawer(id, approvalLevels) {
      this.elDrawerApprovals = true;
      this.currentSelectedBulkUploadId = id;
      this.currentApprovals = approvalLevels;
    },
    async downloadFile(url, selectedMaster) {
      const payload = {
        fileName: this.getFileName(url).slice(0, -5),
        selectedMaster: selectedMaster || this.selectedRejectionMaster,
        data: {
          data: {
            path: url,
          },
        },
      };
      await this.$store.dispatch('mdmV2/downloadExcelFileMdm', payload);
    },
    async getExcelFile(id, subType) {
      const additionalUpload = this.additionalUploads[id.toLowerCase()].filter(e => e.name === subType)[0].is_from_additional_api;
      let sectionId = bfrMapper[id] || id;
      if (subType === 'Gate Bulk Upload'){sectionId = `${sectionId}/gate`}
      if (subType === 'Consignee Secondary User Bulk Upload') {
        sectionId = `${sectionId}/user`;
      }
      if (additionalUpload) {
        await this.$store.dispatch('mdmV2/getadditionalExcelHeader', {
          section: sectionId,
        });
      } else {
        await this.$store.dispatch('mdmV2/getExcelHeader', {
          section: sectionId,
        });
      }
    },
    async loadData($state) {
      this.params.page = this.currentPage;
      const result = await this.$store.dispatch('mdmV2/getBulkUploadListData', this.params);
      if (result && result.error) {
        this.$errorMessage({ message: `${result.error}` });
        $state.complete();
      } else if (result && result.length) {
        const dataProcessingFromListData = cloneDeep(this.tableData.map(item => ({ ...item, hide: false })));
        result.forEach((data) => {
          dataProcessingFromListData.push(this.processData(data));
        });
        this.tableData = cloneDeep(dataProcessingFromListData);
        this.currentPage += 1;
      } else {
        this.isEmptyData = true;
      }
      if ($state) {
        if (!this.isEmptyData) {
          $state.loaded();
        } else {
          $state.complete();
        }
      }
    },
    getFileName(file) {
      const splitData = file.split('/');
      return splitData[splitData.length - 1];
    },
    async fetchTableData() {
      this.params.statuses = [];
      if (this.statuses && this.statuses.length) {
        this.params.statuses.push(...this.statuses);
      }
      this.params.page = 1;
      const result = await this.$store.dispatch('mdmV2/getBulkUploadListData', this.params);
      const dataProcessingFromListData = [];
      result.forEach((data) => {
        dataProcessingFromListData.push(this.processData(data));
      });
      this.tableData = null;
      this.tableData = cloneDeep(dataProcessingFromListData);
    },
    processData(data) {
      const sectionName = this.getSectionNameById.get(
        (data.entity_type === 'rate_matrix') ? 'contract' : data.entity_type,
      );
      const additionalUploadData = this.additionalUploads &&
        this.additionalUploads[(data && data.entity_type === 'rate_matrix') ? 'contract' : data.entity_type] &&
        this.additionalUploads[((data && data.entity_type) === 'rate_matrix') ? 'contract' :
          (data && data.entity_type)].filter(e => e.id === (data && data.entity_sub_type))[0].name;

      const subUploadValue = (data && data.entity_type &&
        data.entity_sub_type && additionalUploadData) ||
        this.mdmUploadPageConstants.MDM_BULK_UPLOAD;
      const obj = {
        client_id: data && data.client_id,
        invalid: data && data.invalid,
        valid: data && data.valid,
        status: data && data.status,
        updateDbId: null,
        transaction_id: data && data.transaction_id,
        uploadedBy: data && data.uploaded_user && data.uploaded_user.email_id,
        fileName: data && data.uploaded_file,
        options: this.additionalUploads[(data && data.entity_type === 'rate_matrix') ? 'contract' : data && data.entity_type],
        // eslint-disable-next-line no-underscore-dangle
        id: data._id,
        menuOptionData: cloneDeep(this.menuOptionData),
        masterSelectvalue: sectionName,
        sectionName,
        subUploadValue,
        isUploaded: [
          mdmUploadStatus.VALIDATION_COMPLETED,
          mdmUploadStatus.VALIDATION_STARTED,
          mdmUploadStatus.VALIDATION_COMPLETED,
          mdmUploadStatus.APPROVAL_PENDING,
          mdmUploadStatus.APPROVED,
          mdmUploadStatus.APPROVAL_REJECTED,
          mdmUploadStatus.UPLOAD_DISCARDED,
        ].includes(data && data.status),
        isApproved: data && data.status === mdmUploadStatus.APPROVED,
        isRejected: data && data.status === mdmUploadStatus.APPROVAL_REJECTED,
        vaildEntries: '-',
        totalRecords: '-',
        rejectionMessage: '',
        ApproveMessage: '',
        splitObject: data && data.split,
        ...(data.event_approvals) ? {
          event_approvals: {
            approval_levels: data.event_approvals.approval_levels &&
              data.event_approvals.approval_levels.map(level => ({
                ...level,
                roleName: this.roles.find(role =>
                  role.id.toString() === level.role_id.toString()).name,
              })),
          },
        } : {},
        canApprove: ((data && data.event_approvals && data.event_approvals.canApprove) ||
          (this.clientConfigApproval && subUploadValue === 'Rate matrix Bulk Upload') ||
          false),
      };
      return obj;
    },
    async handleFileUpload() {
      this.file = this.$refs.additionalUpload.files[0];
      this.$refs.additionalUpload.value = null;
      const groupedTableData = groupBy(this.tableData, this.mdmUploadPageConstants.MDM_SECTION_NAME);
      // field select validation
      if (
        !(
          this.currentRowData &&
          !!this.currentRowData.masterSelectvalue &&
          !!this.file
        )
      ) {
        this.$errorMessage({
          message: this.mdmUploadPageConstants.MDM_MASTER_SELECTION_VALIDATION,
        });
        return;
      }
      if (
        !(
          this.currentRowData &&
          !!this.currentRowData.subUploadValue &&
          !!this.file
        )
      ) {
        this.$errorMessage({
          message: this.mdmUploadPageConstants.MDM_OPTION_SELECTION_VALIDATION,
        });
        return;
      }
      let currentId = this.getIdBySectionName.get(this.currentRowData.sectionName).toLowerCase();
      if (currentId === 'contract') {
        currentId = 'rate_matrix';
      }
      const updateDbId = this.currentRowData.options.filter(e => e.name === this.currentRowData.subUploadValue)[0].id;
      const formData = new FormData();
      formData.append(this.mdmUploadPageConstants.MDM_ATTCHMENT, this.file);
      formData.append(
        'id',
        currentId,
      );
      formData.append(
        'subId',
        updateDbId,
      );
      this.loading = true;
      const result = await this.$store.dispatch('mdmV2/bulkUploadMdm', {
        formData,
      });
      this.loading = false;
      if (result && result.data && result.data.id) {
        const id = result.data.id;
        this.loadingItem.push(id);
        await this.fetchTableData();
        await this.getFileStatus(id);
      } else {
        this.$errorMessage({
          message: result.error,
        });
      }
    },
    async uploadStatusCheck(id) {
      const result = await this.$store.dispatch('mdmV2/getStatusChange', { id });
      if (result) {
        if (
          result.status !== mdmUploadStatus.UPLOAD_STARTED ||
          this.counter >= this.maxTries
        ) {
          this.loadingItem.splice(this.loadingItem.indexOf(id), 1);
          clearInterval(this.intervalId);
          // eslint-disable-next-line no-underscore-dangle
          await this.getUploadItem(result._id);
          await this.fetchTableData();
        }
      }
    },
    async getFileStatus(id) {
      const result = await this.$store.dispatch('mdmV2/getStatusChange', { id });
      if (result && result.status === mdmUploadStatus.UPLOAD_STARTED) {
        this.intervalId = setInterval(() => {
          this.uploadStatusCheck(id);
          this.counter += 1;
        }, 20000);
      } else if (result && result.status === mdmUploadStatus.VALIDATION_COMPLETED) {
        // eslint-disable-next-line no-underscore-dangle
        await this.getUploadItem(result._id);
        await this.fetchTableData();
      }
    },
    upload(row) {
      this.currentRowData = row;
      this.$refs.additionalUpload.click();
    },
    reject(id) {
      this.rejectSelectedId = id;
      this.isRejectSelected = true;
    },
    cancel() {
      this.$refs['ref-popup-close'].click();
    },
    async confirmReject(row, rowIndex) {
      const params = {
        remarks: row.rejectionMessage,
      };
      const id = this.rejectSelectedId;
      const result = await this.$store.dispatch('mdmV2/bulkUploadRejectMdm', {
        id,
        params,
      });
      if (result) {
        await this.getUploadItem(id);
        await this.fetchTableData();
        this.$successMessage({ message: `${row.masterSelectvalue} entries have been rejected` });
        this.tableData[rowIndex].hide = true;
        this.tableData = cloneDeep(this.tableData);
      }
    },
    async approve(row, rowIndex) {
      const id = row.id;
      const result = await this.$store.dispatch('mdmV2/bulkUploadApproveMdm', {
        id,
      });
      if (result) {
        await this.getUploadItem(id);
        await this.fetchTableData();
        this.$successMessage({ message: `${row.masterSelectvalue} entries have been approved and are being updated` });
        this.tableData[rowIndex].hide = true;
        this.tableData = cloneDeep(this.tableData);
      }
    },
    async deleteItem(id) {
      const result = await this.$store.dispatch('mdmV2/bulkUploadDiscardMdm', {
        id,
      });
      if (result) {
        await this.getUploadItem(id);
        await this.fetchTableData();
      }
    },
    async confirm(id, subUploadValue) {
      const result = await this.$store.dispatch('mdmV2/bulkUploadConfirmMdm', {
        id,
      });
      if (result) {
        await this.getUploadItem(id);
        await this.fetchTableData();
        if (!this.$hasFeature('bulk_upload_approval_flow') || !(subUploadValue === 'Rate matrix Bulk Upload')) {
          this.$successMessage({ message: 'Upload Confirmed' });
        } else {
          this.$successMessage({ message: 'Sent for Approval' });
        }
      }
    },

    async refreshStatusScreen() {
      const result = await this.$store.dispatch('mdmV2/getBulkUploadItem', {
        id: this.currentSelectedBulkUploadId,
      });
      if (result) {
        this.currentBatches = result.split;
      }
    },

    async getUploadItem(id) {
      const result = await this.$store.dispatch('mdmV2/getBulkUploadItem', {
        id,
      });
      if (result) {
        const processedData = this.processData(result);
        const updatedRecords = this.tableData.map((upload) => {
          if (upload.id === processedData.id) return processedData;
          return upload;
        });
        this.tableData = cloneDeep(updatedRecords);
      }
    },
    onChangeSubUploadValue(subUploadName, scopeIndex) {
      const change = cloneDeep(this.tableData);
      this.updateDbId = change[scopeIndex].options.filter(e => e.name === subUploadName)[0].id;
      const currentId = this.getIdBySectionName.get(change[scopeIndex].sectionName).toLowerCase();
      this.currentId = currentId;
      change[scopeIndex].fileName = this.sampleFileNameMaster[subUploadName];
      this.tableData = change;
    },
    onChangeMasterSelectValue(sectionName, scopeIndex) {
      const change = cloneDeep(this.tableData);
      change[scopeIndex].sectionName = sectionName;
      change[scopeIndex].options = [];
      change[scopeIndex].fileName = null;
      change[scopeIndex].subUploadValue = null;
      const currentId = this.getIdBySectionName.get(change[scopeIndex].sectionName).toLowerCase();
      const subUploads = this.additionalUploads[currentId].filter(subUpload => (!subUpload.permission || this.$hasPermission(subUpload.permission)) && (!subUpload.feature || this.$hasFeature(subUpload.feature)));
      change[scopeIndex].options = subUploads;

      change[scopeIndex].uploadedBy = this.bootstrapData.current_user.email;
      this.tableData = change;
    },
    uploadNewMaster() {
      const change = cloneDeep(this.tableData);
      change.unshift({
        options: [],
        totalRecords: '-',
        vaildEntries: '-',
        id: null,
        menuOptionData: cloneDeep(this.menuOptionData),
        masterSelectvalue: '',
        subUploadValue: '',
        status: '',
        uploadedBy: this.bootstrapData.current_user.email,
        isUploaded: false,
        isApproved: false,
        isRejected: false,
        rejectMessage: '',
        ApproveMessage: '',
        fileName: '',
        sectionName: '',
      });
      this.tableData = change;
    },
    closeEditSlider() {
      this.elDrawer = false;
    },
    closeStatusSlider() {
      this.elDrawerStatus = false;
    },
    closeApprovalSlider() {
      this.elDrawerApprovals = false;
    },
    isPending(row) {
      return row.status === mdmUploadPageConstants.MDM_PENDING || row.status === '';
    },
  },
  async created() {
    if (!this.previousRoute) {
      this.previousRoute = localStorage.getItem('mdm-upload-section');
    }
    await this.$store.dispatch('role/list');
    this.clientConfigApproval =
      this.$hasPermission('mdm_approval') &&
      this.$hasPermission('mdm_approval_accept_reject') &&
      this.$hasFeature('bulk_upload_approval_flow'); //  approval flow config
    // Showing 6 statuses only for those clients with below feature
    if (this.$hasFeature('bulk_upload_approval_flow')) {
      this.filterOptions = [...this.filterOptionsForApprover, ...this.filterOptions];
    }
    this.filterOptions.forEach((option) => {
      option.selected = false;
      option.cleared = false;
    });
    const currentRoute = this.$router.history.current.name.toLowerCase();
    this.tableData = [];
    this.getSectionNameById = new Map(
      this.menuOptionData.map(object => [
        object.id.toLowerCase(),
        object.name,
      ]),
    );
    this.getIdBySectionName = new Map(
      this.menuOptionData.map(object => [object.name, object.id]),
    );
    const isMasterPermissionEnable = this.checkPermission();
    this.menuOptionData = this.menuOptionData.filter(menu =>
      (menu.is_bulk_upload_v2 && isMasterPermissionEnable.includes(menu.id.toLowerCase()) && this.$hasPermission(menu.permission.toLowerCase())),
    );
    if ((currentRoute === this.mdmUploadPageConstants.MDM_UPLOAD) && !!this.previousRoute) {
      this.uploadNewMaster();
      this.tableData[0].sectionName = this.getSectionNameById.get(
        this.previousRoute.toLowerCase(),
      );
      this.tableData[0].masterSelectvalue = this.getSectionNameById.get(
        this.previousRoute.toLowerCase(),
      );
      this.tableData[0].options =
        this.additionalUploads[this.previousRoute.toLowerCase()].filter(subUpload => (!subUpload.permission || this.$hasPermission(subUpload.permission)) && (!subUpload.feature || this.$hasFeature(subUpload.feature)));
      this.tableData[0].uploadedBy = this.bootstrapData.current_user.email;
    }
    this.currentRowData = this.tableData[0];
  },
};
</script>
